import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { common } from '../common';

export const horizontalScrollablePanelBoughtThisSeason = mergeMultipleConfigs(
  common.horizontalScrollablePanelBoughtThisSeason,
  [
    {
      id: 'root',
      data: {
        aggregationType: 1,
        dateRangeField: 1,
      },
    },
  ],
)[0];
